import React, { type ReactNode } from 'react';

import { type SwitchProps as RadixSwitchProps } from '@radix-ui/react-switch';

import { Container, StyledSwitch, StyledSwitchThumb, SwitchLabel } from './styles';

export interface SwitchProps {
    id?: RadixSwitchProps['id'];
    label?: string;
    value?: RadixSwitchProps['value'];
    checked?: RadixSwitchProps['checked'];
    disabled?: RadixSwitchProps['disabled'];
    required?: RadixSwitchProps['required'];
    onCheckedChange?: RadixSwitchProps['onCheckedChange'];
    children?: ReactNode;
}

// TODO: The `SwitchLabel` should be moved inside of `StyledSwitch` so that it
// receives the interaction events to also toggle the `checked` state.
export function Switch({ id, label, value, checked, disabled, required, onCheckedChange, children }: SwitchProps) {
    return (
        <Container>
            <StyledSwitch
                id={id}
                value={value}
                checked={checked}
                disabled={disabled}
                required={required}
                onCheckedChange={onCheckedChange}
            >
                <StyledSwitchThumb />
                {children}
            </StyledSwitch>

            <SwitchLabel>{label}</SwitchLabel>
        </Container>
    );
}
